export const REMEMBER_NEXT_SPREADS_TOOLTIP = "rememberNextSpreadsTooltip";
